// ── Certificate issue hook (FR-CERT) ────────────────────────────────────────
// POST /certificates issue is SA/Admin-only (issue.certificates) + a UUID
// Idempotency-Key. On success the issue response row is patched into the list
// cache (class-12 write-truth) — never list invalidate. artifactRef null = pending.

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCoachingReadinessServices } from "../services/coaching-service-provider";
import type { CoachingCertificateIssueRequest } from "../services/coaching-readiness-dtos";
import { cacheCertificateIssueReadback } from "./coaching-write-truth-caches";
import { createIdempotencyKey } from "./useCoachingQueries";

export function useCertificateIssueMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CoachingCertificateIssueRequest) =>
      getCoachingReadinessServices().certificates.issue(
        body,
        createIdempotencyKey(`certificate-issue:${body.participantId}:${body.cohortId}`)
      ),
    onSuccess: (data) => {
      if (data?.certificate) cacheCertificateIssueReadback(queryClient, data.certificate);
    }
  });
}
